"use client";

import React from "react";
import { createRoot, Root } from "react-dom/client";

// --- Popup component ---
interface PopupProps {
  title: string;
  message: string;
  onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ title, message, onClose }) => {
  return (
    <div className="emission-popup-overlay">
      <div className="emission-popup-card">
        <div className="emission-popup-header">
          <h3 className="emission-popup-title">{title}</h3>
          <button
            className="close-btn emission-popup-close-btn"
            aria-label="Close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        <div className="emission-popup-body">
          <p className="emission-popup-description">{message}</p>
        </div>
      </div>
    </div>
  );
};

// --- Popup manager ---
interface PopupData {
  id: number;
  title: string;
  message: string;
}

let popup: PopupData | null = null;
let container: HTMLElement | null = null;
let root: Root | null = null;

function getRoot(): Root {
  if (!container) {
    container = document.createElement("div");
    container.className = "popup-container-wrapper";
    document.body.appendChild(container);
    root = createRoot(container);
  }
  return root!;
}

function renderPopup() {
  const r = getRoot();

  if (!popup) {
    r.render(<></>); // render nothing
    return;
  }

  r.render(
    <Popup
      key={popup.id}
      title={popup.title}
      message={popup.message}
      onClose={clearPopup}
    />
  );
}

function clearPopup() {
  popup = null;
  renderPopup();
}

// --- Function you can call anywhere ---
export function showPopup(title: string, message: string, ) {
  if (typeof window === "undefined") return;

  popup = {
    id: Date.now() + Math.random(),
    title,
    message
  };

  renderPopup();
}
